import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import {
  BUS_MAINTENANCE_STAY_PATH,
  IDLING_CONSUMPTION_PATH,
} from '../../../../config/paths';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import IdlingConsumptionObservationForm from './IdlingConsumptionObservationForm';
import {
  clearIdlingConsumptionObservation,
  getIdlingConsumptionObservation,
  putIdlingConsumptionObservation,
} from '../../../../actions';

const EditIdlingConsumptionObservation = ({
  breadcrumbs,
  dispatchClearIdlingConsumptionObservation,
  dispatchGetIdlingConsumptionObservation,
  dispatchPutIdlingConsumptionObservation,
  match: {
    params: { id: idlingConsumptionObservationId },
  },
  loading,
  idlingConsumptionObservation,
}) => {
  useLayoutEffect(() => {
    dispatchGetIdlingConsumptionObservation({ idlingConsumptionObservationId });

    return () => dispatchClearIdlingConsumptionObservation();
  }, []);

  const onSubmit = (formValues) => {
    const newFormValues = {
      ...formValues,
      idlingConsumptionMotiveId: idlingConsumptionObservation.get(
        'idlingConsumptionMotiveId',
      ),
    };

    dispatchPutIdlingConsumptionObservation(
      idlingConsumptionObservationId,
      newFormValues,
    );
  };

  const generateInitialValues = ({
    itineraryId,
    idlingConsumptionMotive,
    idlingConsumptionTime,
    idlingConsumptionNumberOfGallon,
    realIdlingConsumptionTime,
    realIdlingConsumptionNumberOfGallon,
    observation,
  }) => ({
    itineraryId,
    idlingConsumptionMotiveId: idlingConsumptionMotive.description,
    idlingConsumptionTime,
    idlingConsumptionNumberOfGallon,
    realIdlingConsumptionTime,
    realIdlingConsumptionNumberOfGallon,
    observation,
  });

  let content;

  if (loading) content = <Loader />;
  else if (idlingConsumptionObservation.isEmpty())
    content = <NoDataResource returnPage={BUS_MAINTENANCE_STAY_PATH} />;
  else
    content = (
      <IdlingConsumptionObservationForm
        onSubmit={onSubmit}
        initialValues={generateInitialValues(
          idlingConsumptionObservation.toJS(),
        )}
      />
    );

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Control de Consumo por Ralentí"
      subtitle="Editar control de consumo por ralentí"
      content={content}
    />
  );
};

EditIdlingConsumptionObservation.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetIdlingConsumptionObservation: PropTypes.func.isRequired,
  dispatchClearIdlingConsumptionObservation: PropTypes.func.isRequired,
  dispatchPutIdlingConsumptionObservation: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  idlingConsumptionObservation: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditIdlingConsumptionObservation.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearIdlingConsumptionObservation: clearIdlingConsumptionObservation,
  dispatchGetIdlingConsumptionObservation: getIdlingConsumptionObservation,
  dispatchPutIdlingConsumptionObservation: putIdlingConsumptionObservation,
};

const mapStateToProps = (
  { TrafficUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...TrafficUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Control de Consumos por Ralentí',
      href: IDLING_CONSUMPTION_PATH,
    },
    {
      text: 'Ver',
      href: `${IDLING_CONSUMPTION_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  idlingConsumptionObservation: TrafficUnit.IdlingConsumption.getIn([
    'current',
    'content',
  ]),
  loading: !TrafficUnit.IdlingConsumption.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditIdlingConsumptionObservation);
